import React from 'react';

interface StartupIconProps {
  size?: number | string;
  className?: string;
  variant?: 'default' | 'monochrome' | 'outline' | 'filled';
  color?: string;
}

/**
 * High-quality icon component using the startup logo as the base
 * Provides consistent branding across the application
 */
export const StartupIcon: React.FC<StartupIconProps> = ({
  size = 24,
  className = '',
  variant = 'default',
  color,
}) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size;

  const getVariantStyles = () => {
    switch (variant) {
      case 'monochrome':
        return {
          filter: 'grayscale(100%) brightness(0.5)',
        };
      case 'outline':
        return {
          filter: 'brightness(0) saturate(100%)',
          opacity: 0.6,
        };
      case 'filled':
        return {
          filter: 'none',
        };
      default:
        return {};
    }
  };

  return (
    <img
      src="/startup_logo.png"
      alt="insora"
      width={sizeValue}
      height={sizeValue}
      className={`startup-icon ${className}`}
      data-variant={variant}
      style={{
        color: color,
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
};

export default StartupIcon;
